import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class ChemicalService {
  public chemicalTypes = [
    'Algicide',
    'Aromatherapy',
    'Balancer',
    'Bromine',
    'Chlorine',
    'Enzymes',
    'Foam Remover',
    'Jet Cleaner',
    'pH Modifiers',
    'Shock'
  ];

  constructor() { }
}
